var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkWhite = function SvgIconLinkWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.323 5.848a.833.833 0 1 1 0-1.667h6.827c.92 0 1.667.746 1.667 1.667v6.827a.833.833 0 1 1-1.667 0V7.026l-8.3 8.3a.833.833 0 0 1-1.179-1.178l8.3-8.3z"
  })));
};
export default SvgIconLinkWhite;